<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p>To the memory of both Larry and Peggy’s beloved parents, Mary Marguerite Norris Gregg Smith, William Durell Franks, and Opal Tidwell Franks whose faith and encouragement have made any of our meaningful accomplishments possible.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?00bc8ab0